import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";

import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "myschedule-config",
    templateUrl: "./myschedule-config.view.html",
    providers: []
})
export class MyscheduleConfigView implements OnInit {
    baseUrl = "";
    expansionStyle = "";
    headerConfig: any = {};
    drawerControlConfig: any = {};
    tabConfig: any = {};
    buttonConfig: any = {};
    iconList = [
        {
            label: "Calendar",
            class: "fa-calendar"
        }
    ];
    borderStyles: any = [
        {
            label: "Thick Color Underline",
            code: "solid"
        },
        {
            label: "Dashed Color Underline",
            code: "dashed"
        },
        {
            label: "Dotted Color Underline",
            code: "dotted"
        }
    ];

    constructor(public sharedService: SharedService, private activatedRoute: ActivatedRoute) {
        if (this.activatedRoute.parent.routeConfig.path == "session") {
            this.baseUrl = sharedService.sessionUrl;
            this.headerConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].my_schedule.my_schedule_header;
            this.drawerControlConfig = this.sharedService.sessionLayoutConfig[this.baseUrl].my_schedule.my_schedule_drawer_button;
            this.expansionStyle = this.sharedService.expansionStyle;
        }
    }

    ngOnInit() {}
}
